"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _propTypeAction = _interopRequireDefault(require("./propTypeAction"));

var _index = require("./index.styles");

var _ActionButton = _interopRequireDefault(require("./ActionButton"));

var _excluded = ["title", "children", "actions"];
/**
 * Use `Alert` to provide local feedback, relative to another element.
 *
 * For global feedback, you may want to use a `Toaster`.
 */

var Alert = function Alert(_ref) {
  var title = _ref.title,
      children = _ref.children,
      actions = _ref.actions,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_index.Container, (0, _extends2["default"])({
    role: "alert"
  }, props), title && title.length > 1 ? /*#__PURE__*/_react["default"].createElement(_index.Title, {
    "data-testid": "title"
  }, title) : null, /*#__PURE__*/_react["default"].createElement(_index.Content, {
    "data-testid": "content"
  }, children), actions.length ? /*#__PURE__*/_react["default"].createElement(_index.Actions, null, actions) : null);
};

Alert.propTypes = {
  children: _propTypes.node,
  title: _propTypes.string,
  variant: (0, _propTypes.oneOf)(['info', 'warning', 'success', 'error']),
  actions: (0, _propTypes.arrayOf)(_propTypeAction["default"])
};
Alert.defaultProps = {
  variant: 'info',
  actions: []
};
Alert.ActionButton = _ActionButton["default"];
var _default = Alert;
exports["default"] = _default;